import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import styles from "./Overlay.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function Overlay({
  children,
  open = true,
  className
}) {
  const ref = useRef(null);
  useEffect(() => {
    return () => {
      clearAllBodyScrollLocks();
    };
  }, []);
  useEffect(() => {
    if (ref.current) {
      if (open) {
        disableBodyScroll(ref.current);
      } else {
        enableBodyScroll(ref.current);
      }
    }
  }, [open]);
  if (!open) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: classNames(styles.overlay, className),
    children: children
  });
}